import { TableConditionApi } from 'cadenza/api-client/conditions/table-condition-api';

export class TreeConditionApi extends TableConditionApi {

  constructor ({ conditionSetId, conditionName, conditionId, conditionValuesSetHashGetter } = {}) {
    super({ conditionSetId, conditionName, conditionId, conditionValuesSetHashGetter }, '/treeConditionQuery');
  }

}
